export const laws = {
  methods: {
    //获取树形法律法规
    async LawTreeSelect() {
      let res = await this.$http.get("/tenant/law/tenant/tree/list");
      return res;
    },
    //获取租户端法律法规
    async LawTreeSelectContent(queryParams) {
      let res = await this.$http.get(
        "/tenant/law/tenant/list",
        queryParams
      );
      return res;
    },

    /****************************规章制度**********************************/
    //获取级别树形
    async ruleTree() {
      let res = await this.$http.get("/tenant/rule/getRuleTree");
      return res;
    },
    //TODO: 新增级别
    async addRule(data) {
      if(!data.parentId){
        data.parentId=0;
      }
      let res = await this.$http.post("/tenant/rule/add", data);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //TODO:修改级别
    async upRule(data) {
      let res = await this.$http.put("/tenant/rule/edit", data);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //TODO:删除级别
    async delRule(id) {
      let res = await this.$http.delete(`/tenant/rule/delete/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //查询所有规章制度
    async regulationsList(params) {
      let {ruleId,regulationName,pageNum,pageSize ,content } = params
      let res = await this.$http.get("/tenant/regulations/list",{
        ruleId:ruleId??null,
        content:content,
        regulationName:regulationName??null,
        pageNum:pageNum??null,
        pageSize:pageSize??null
      });
      return res;
    },
    //TODO: 新增规章制度
    async addRegulation(data) {
      let res = await this.$http.post("/tenant/regulations/add", data);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //TODO:修改规章制度
    async upRegulation(data) {
      let res = await this.$http.put("/tenant/regulations/edit", data);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //TODO:删除规章制度
    async delRegulation(id) {
      let res = await this.$http.delete(`/tenant/regulations/delete/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
  },
};


